import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { ReactComponent as SingleCountSvg } from '../../assets/single-count.svg';
import { ReactComponent as MultipleCountSvg } from '../../assets/multiple-count.svg';

interface CountIndicatorProps {
  value?: number | string | null;
  size?: number;
}

export const CountIndicator: React.FC<CountIndicatorProps> = ({ value, size = 30 }) => {
  if (Number(value) > 1) {
    return <MultipleCountSvg width={size} height={size} />;
  }

  return <SingleCountSvg width={size} height={size} />;
};

const CountCellRenderer: React.FC<ICellRendererParams> = params => {
  return <CountIndicator value={params.value as number | string | null | undefined} />;
};

export default CountCellRenderer;
